import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getClientConfig } from '../../config/clientConfig';
import HELPERS from '../../utils/helper';
import { Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import './template10.css';

// College Template - Professional & Comprehensive Design
class EnquiryTemplate10 extends Component {
  constructor(props) {
    super(props);
    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        area: '',
        course: '',
        message: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
    };
  }

  componentDidMount() {
    if (this.state.clientConfig) {
      this.fetchAreas();
      this.fetchCourses();
    }
  }

  fetchAreas = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };
      const areasUrl = apis.getAreasUrl(clientConfig);
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);
      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      }
    } catch (err) {
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: ['Vesu', 'Adajan', 'Varachha', 'Piplod', 'City Light', 'Athwa', 'Rander', 'Althan']
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Full name is required';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.course.trim()) {
      errors.course = 'Please select a program';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({ loader: true, disabled: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email || '',
        comments: formData.message || 'No additional message',
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: formData.course || '',
        state: clientConfig.api.defaults.state,
        city: clientConfig.api.defaults.city,
        area: formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 || res.status === 201) {
        Toast('Application submitted successfully! Our admission team will contact you shortly.', toastMsgConfig('s'));
        this.setState({
          formData: {
            name: '',
            phone: '',
            email: '',
            area: '',
            course: '',
            message: ''
          },
          loader: false,
          disabled: false
        });
      } else {
        Toast('Unable to submit application. Please try again.', toastMsgConfig('e'));
        this.setState({ loader: false, disabled: false });
      }
    } catch (error) {
      Toast('Failed to submit application. Please try again later.', toastMsgConfig('e'));
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, areas, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    return (
      <div className="template10-container">
        {/* Hero Banner */}
        <div className="template10-hero">
          <div className="template10-hero-overlay"></div>
          <div className="template10-hero-content">
            <div className="template10-logo-section">
              <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
            </div>
            <h1>{clientConfig.clientName}</h1>
            <p className="template10-tagline">{clientConfig.branding.heroSubtitle}</p>
            <div className="template10-hero-badges">
              <span className="template10-badge">{clientConfig.branding.badgeText}</span>
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="template10-stats-bar">
          <div className="template10-stats-container">
            <div className="template10-stat-item">
              <i className="fa fa-graduation-cap"></i>
              <div>
                <strong>{clientConfig.stats.alumni}</strong>
                <span>Alumni Network</span>
              </div>
            </div>
            <div className="template10-stat-item">
              <i className="fa fa-building"></i>
              <div>
                <strong>{clientConfig.stats.experience} Years</strong>
                <span>Legacy</span>
              </div>
            </div>
            <div className="template10-stat-item">
              <i className="fa fa-briefcase"></i>
              <div>
                <strong>{clientConfig.stats.placement}</strong>
                <span>Placements</span>
              </div>
            </div>
            <div className="template10-stat-item">
              <i className="fa fa-handshake"></i>
              <div>
                <strong>{clientConfig.stats.partners}+</strong>
                <span>Industry Partners</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="template10-main">
          <div className="template10-content-wrapper">
            {/* Application Form */}
            <div className="template10-form-section">
              <div className="template10-form-header">
                <h2>Apply for Admission</h2>
                <p>Take the first step towards your bright future</p>
              </div>

              <form onSubmit={this.handleSubmit} className="template10-form">
                <div className="template10-form-row">
                  <div className="template10-form-group">
                    <label>Full Name <span className="required">*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={this.handleChange}
                      placeholder="Enter your full name"
                      className={errors.name ? 'error' : ''}
                    />
                    {errors.name && <span className="template10-error">{errors.name}</span>}
                  </div>

                  <div className="template10-form-group">
                    <label>Phone Number <span className="required">*</span></label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={this.handleChange}
                      placeholder="10-digit mobile number"
                      maxLength="10"
                      className={errors.phone ? 'error' : ''}
                    />
                    {errors.phone && <span className="template10-error">{errors.phone}</span>}
                  </div>
                </div>

                <div className="template10-form-row">
                  <div className="template10-form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={this.handleChange}
                      placeholder="your.email@example.com"
                      className={errors.email ? 'error' : ''}
                    />
                    {errors.email && <span className="template10-error">{errors.email}</span>}
                  </div>

                  <div className="template10-form-group">
                    <label>Area / Location</label>
                    <select
                      name="area"
                      value={formData.area}
                      onChange={this.handleChange}
                    >
                      <option value="">Select your area</option>
                      {areas.map((area, index) => (
                        <option key={index} value={area}>{area}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="template10-form-group">
                  <label>Program of Interest <span className="required">*</span></label>
                  <select
                    name="course"
                    value={formData.course}
                    onChange={this.handleChange}
                    className={errors.course ? 'error' : ''}
                  >
                    <option value="">Select a program</option>
                    {courses.map((course, index) => (
                      <option key={index} value={course}>{course}</option>
                    ))}
                  </select>
                  {errors.course && <span className="template10-error">{errors.course}</span>}
                </div>

                <div className="template10-form-group">
                  <label>Additional Information</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={this.handleChange}
                    placeholder="Tell us about your educational background, goals, or any questions you have..."
                    rows="4"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="template10-submit-btn"
                  disabled={disabled || loader}
                >
                  {loader ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i> Submitting Application...
                    </>
                  ) : (
                    <>
                      Submit Application <i className="fa fa-paper-plane"></i>
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Sidebar Info */}
            <div className="template10-sidebar">
              <div className="template10-info-card">
                <h3>Why Choose Us?</h3>
                <ul className="template10-features-list">
                  {clientConfig.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fa fa-check-circle"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="template10-info-card template10-contact-card">
                <h3>Get in Touch</h3>
                <div className="template10-contact-list">
                  <div className="template10-contact-detail">
                    <i className="fa fa-phone"></i>
                    <div>
                      <strong>Call Us</strong>
                      <p>{clientConfig.contactInfo.phone1}</p>
                      <p>{clientConfig.contactInfo.phone2}</p>
                    </div>
                  </div>
                  <div className="template10-contact-detail">
                    <i className="fa fa-envelope"></i>
                    <div>
                      <strong>Email</strong>
                      <p>{clientConfig.contactInfo.email}</p>
                    </div>
                  </div>
                  <div className="template10-contact-detail">
                    <i className="fa fa-globe"></i>
                    <div>
                      <strong>Website</strong>
                      <p>{clientConfig.contactInfo.website}</p>
                    </div>
                  </div>
                  <div className="template10-contact-detail">
                    <i className="fa fa-map-marker"></i>
                    <div>
                      <strong>Campus Address</strong>
                      <p>{clientConfig.contactInfo.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const ConnectedEnquiryTemplate10 = connect(mapStateToProps)(EnquiryTemplate10);
export default ConnectedEnquiryTemplate10;
